export const AI_INTERVIEWS_FIRST_MESSAGE =
  "Hey there! Let us know if you're ready to start the interview.";
export const AI_INTERVIEWS_LAST_MESSAGE =
  "Thank you for answering Screening questions. We'll get back to you soon. In the meantime you can update your Profile and add info.";
